import React, { useContext, useState } from "react";
import {  BrowserRouter } from "react-router-dom";
import { PageProvider } from "./context/PageContext";
import Nav from "./components/layout/Nav/";
import Routes from './Routes';

const { REACT_APP_BASENAME } = process.env;

const App = () => {
    return (
        <BrowserRouter basename={REACT_APP_BASENAME}>
            <PageProvider> 
                <Nav />
                <Routes />
            </PageProvider> 
        </BrowserRouter>
    );
}
export default App;
 